import GetApiDialog from "../api-viewer/GetApiDialog";
import { AWSMarketplaceButton } from "../aws/AWSMarketplaceButton";

export const MenuItems = () => {
  return (
    <div className="ml-auto flex flex-wrap justify-end gap-x-4 gap-y-2 mobile:gap-x-1.5">
      <AWSMarketplaceButton />
      <GetApiDialog />
    </div>
  );
};
